import { render, staticRenderFns } from "./SocietyDetails.vue?vue&type=template&id=4dcdb532&scoped=true"
import script from "./SocietyDetails.vue?vue&type=script&lang=js"
export * from "./SocietyDetails.vue?vue&type=script&lang=js"
import style0 from "./SocietyDetails.vue?vue&type=style&index=0&id=4dcdb532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcdb532",
  null
  
)

export default component.exports